import { render, staticRenderFns } from "./infoForm2.vue?vue&type=template&id=2ee97f2e&scoped=true&"
import script from "./infoForm2.vue?vue&type=script&lang=js&"
export * from "./infoForm2.vue?vue&type=script&lang=js&"
import style0 from "./infoForm2.vue?vue&type=style&index=0&id=2ee97f2e&scoped=true&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./infoForm2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee97f2e",
  null
  
)

export default component.exports